
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarGroupLabel, 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton 
} from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import ROUTES from '@/routes-map';

const MarketingGroup: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Marketing</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.ADVERTISEMENTS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.ADVERTISEMENTS}>
                <Megaphone className="h-5 w-5" />
                <span>Advertisements</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default MarketingGroup;
